export default __webpack_public_path__ + "static/media/Feat3.7463e053.jpeg";